import { createRoot } from 'react-dom/client'
import { ErrorBoundary } from "react-error-boundary";

import './i18n'
import i18n from './i18n'
import { getCachedGeoLocale } from './lib/geo-locale'
import App from './App.tsx'
import { ErrorFallback } from './ErrorFallback.tsx'
import { storeTrafficSource } from './lib/analytics'
import { installAuthFetchInterceptor } from './lib/auth-token'

import "./main.css"
import "./styles/theme.css"
import "./index.css"

const API_BASE_URL = import.meta.env.VITE_API_URL || 'http://localhost:4000'

// Ensure authenticated API calls keep Authorization header even in modules
// that still use direct fetch.
installAuthFetchInterceptor(API_BASE_URL)

// Apply geo-detected language on cached visits (before first render)
const cachedGeo = getCachedGeoLocale()
if (cachedGeo && !localStorage.getItem('i18nextLng')) {
  i18n.changeLanguage(cachedGeo.language)
}

// Store first-touch attribution without loading third-party trackers.
// Non-essential analytics and marketing scripts are initialized after consent.
storeTrafficSource()

createRoot(document.getElementById('root')!).render(
  <ErrorBoundary FallbackComponent={ErrorFallback}>
    <App />
   </ErrorBoundary>
)
